const sectionCardKeyFeaturesCss = `
[data-type='section-card-key-features'] .key-features-wrapper {
  padding-block: 40px;
  background-color: var(--data-background-color, #ffffff);
}

[data-type='section-card-key-features'] .key-features-header h1,
[data-type='section-card-key-features'] .key-features-header h2,
[data-type='section-card-key-features'] .key-features-header h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-key-features'] .key-features-header h1:last-child,
[data-type='section-card-key-features'] .key-features-header h2:last-child,
[data-type='section-card-key-features'] .key-features-header h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-key-features'] .key-features-header p {
  font-size: 16px;
  margin: 0 !important;
}

[data-type='section-card-key-features'] .key-features-header p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-key-features'] .key-features-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 32px;
  margin-top: 24px;
}

[data-type='section-card-key-features'] .key-feature-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

[data-type='section-card-key-features'] .key-feature-card .key-feature-image {
  margin-bottom: 12px;
  aspect-ratio: 5/3;
  max-height: 400px;
  min-height: fit-content;
}

[data-type='section-card-key-features'] .key-feature-card .key-feature-image img {
  border-radius: 12px;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,
    rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.1) 0px 8px 10px -6px;
  border: 1px solid #d1d5db;
}

[data-type='section-card-key-features'] .key-feature-card .key-feature-content h1,
[data-type='section-card-key-features'] .key-feature-card .key-feature-content h2,
[data-type='section-card-key-features'] .key-feature-card .key-feature-content h3 {
  font-size: 20px;
  line-height: normal;
  margin: 0 0 8px 0 !important;
}

[data-type='section-card-key-features'] .key-feature-card .key-feature-content h1:last-child,
[data-type='section-card-key-features'] .key-feature-card .key-feature-content h2:last-child,
[data-type='section-card-key-features'] .key-feature-card .key-feature-content h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-key-features'] .key-feature-card .key-feature-content p {
  font-size: 14px;
  margin: 0 !important;
}

[data-type='section-card-key-features'] .key-feature-card .key-feature-content p:last-child {
  margin-bottom: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-card-key-features'] .key-features-wrapper {
    padding-block: 24px;
  }

  [data-type='section-card-key-features'] .key-features-header h1,
  [data-type='section-card-key-features'] .key-features-header h2,
  [data-type='section-card-key-features'] .key-features-header h3 {
    font-size: 20px;
  }

  [data-type='section-card-key-features'] .key-features-header p {
    font-size: 14px;
  }

  [data-type='section-card-key-features'] .key-features-grid {
    grid-template-columns: 1fr;
  }
}
`;
export default sectionCardKeyFeaturesCss;
